import { Injectable } from '@angular/core';
import { IIDolRispostaSollecitoStore } from './iidOlRispostaSollecito.store';
import { IID_OL_RISPOSTA_SOLLECITO } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDolRispostaSollecitoQuery } from './iidOlRispostaSollecito.query'
import { CrudService } from '../crudService';
import { IssueEntityStoreStrategy } from '../updateStoreStrategies';
@Injectable({
  providedIn: 'root'
})
export class IIDolRispostaSollecitoService extends CrudService<IID_OL_RISPOSTA_SOLLECITO, IIDolRispostaSollecitoStore, IIDolRispostaSollecitoQuery> {
  constructor(
    protected store: IIDolRispostaSollecitoStore,
    protected query: IIDolRispostaSollecitoQuery,
    protected actionService: ActionService,
    protected updateStrategy: IssueEntityStoreStrategy) {
    super(
      Topics.IID_OL_RISPOSTA_SOLLECITO,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
